import { FilterDropdown } from "Components/Shared/Components/FilterDropdown";
import { Resources, useResource } from "Translations/Resources";
import type { TimePeriod } from "Types/TimePeriod";

const PageResources = Resources.Components.Shared.Filters;

type Props = {
  value?: TimePeriod;
  onChange: (value: TimePeriod | undefined) => void;
};

export const TimePeriodFilterDropdown = ({ value, onChange }: Props) => {
  const { t } = useResource();

  const options = [
    { value: "day", label: t(PageResources.TimePeriodLabels.day) },
    { value: "week", label: t(PageResources.TimePeriodLabels.week) },
    { value: "month", label: t(PageResources.TimePeriodLabels.month) },
    { value: "custom", label: t(PageResources.TimePeriodLabels.custom) },
  ];

  const handleChange = (newValue: string | number) => {
    // Empty string (from clear action) means no filter - set to undefined
    onChange(newValue === "" ? undefined : (newValue as TimePeriod));
  };

  return (
    <FilterDropdown
      label={t(PageResources.TimePeriod)}
      placeholder={t(PageResources.Unlimited)}
      options={options}
      value={value ?? ""}
      onChange={handleChange}
    />
  );
};
